export const CONSTANT = {
  encodingType: [
    {
      label: 'UTF-8',
      value: 'UTF-8',
    },
    {
      label: 'WINDOWS-874',
      value: 'WINDOWS-874'
    }
  ]
};

export enum CeleryStatus {
  Pending = 'PENDING',
  Progress = 'PROGRESS',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
  Revoked = 'REVOKED',
}

export const SUPPORT_FORMAT = ['application/pdf'];

export const ITEMS_PER_PAGE_OPTIONS = [
  {label: '40', value: 40},
  {label: '100', value: 100}
];

export const PAGINATION = {
  MAX_SIZE: 10,
  PAGE_SIZE: 40
};

export const DOC_TEMPLATES = [
  {
    name: 'ใบกำกับภาษี',
    nameEN: 'Tax Invoice',
    type: 'tax_invoice',
    allowedRoles: ['Accountant']
  },
  // {
  //   name: 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
  //   nameEN: 'Receipt/Tax Invoice',
  //   type: 'receipt_tax_invoice',
  //   allowedRoles: ['Back Office', 'Front', 'FB/Outlet', 'Accountant']
  // },
  // {
  //   name: 'ใบแจ้งหนี้/ใบกำกับภาษี',
  //   nameEN: 'Invoice/Tax Invoice',
  //   type: 'invoice_tax_invoice',
  //   allowedRoles: ['Back Office', 'Accountant']
  // },
  // {
  //   name: 'ใบส่งของ/ใบกำกับภาษี',
  //   nameEN: 'Delivery Order/Tax Invoice',
  //   type: 'delivery_order_tax_invoice',
  //   allowedRoles: ['Back Office', 'Accountant']
  // },
  {
    name: 'ใบเสร็จรับเงิน',
    nameEN: 'Receipt',
    type: 'receipt',
    allowedRoles: ['Back Office', 'Accountant']
  },
  // {
  //   name: 'ใบแจ้งหนี้',
  //   nameEN: 'Invoice',
  //   type: 'invoice',
  //   allowedRoles: ['Back Office', 'Accountant']
  // },
  {
    name: 'ใบลดหนี้',
    nameEN: 'Credit Note',
    type: 'credit_note',
    allowedRoles: ['Back Office', 'Accountant']
  },
  {
    name: 'ใบเพิ่มหนี้',
    nameEN: 'Debit Note',
    type: 'debit_note',
    allowedRoles: ['Back Office', 'Accountant']
  },
];
export const MODAL_CONFIG = {
  animated: true,
  class: 'modal-dialog-centered'
};

export const CALENDAR_LOCALE = {
  TH: {
    firstDayOfWeek: 0,
    dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
    dayNamesShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
    dayNamesMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    monthNames: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
    monthNamesShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
    today: 'วันนี้',
    clear: 'ล้างข้อมูล'
  },
  EN: {
    firstDayOfWeek: 0,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'],
    dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'],
    today: 'Today',
    clear: 'Clear'
  }
};

export const CUSTOMER_TYPES = [
  {
    name: 'นิติบุคคลในประเทศ',
    nameEN: 'Thailand Corporation',
    type: 'thailand_corporation',
    value: 0
  },
  {
    name: 'บุคคลธรรมดา',
    nameEN: 'Ordinary Person',
    type: 'ordinary_person',
    value: 2
  },
  {
    name: 'นิติบุคคลต่างประเทศ',
    nameEN: 'Foreign Corporation',
    type: 'foreign_corporation',
    value: 1
  },
  {
    name: 'บริษัทในเครือ',
    nameEN: 'Affiliated Corporation',
    type: 'affiliated_corporation',
    value: 3
  },
];




// WEBPACK FOOTER //
// /opt/app/src/app/services/constant.ts